export class BearerToken {
  constructor(
        public readonly accessToken: string,
        public readonly accessTokenExpiredAt: Date,
        public readonly refreshToken: string,
        public readonly refreshTokenExpiredAt: Date
  ) {}
}